/**
 * Shared field→label metadata for Enalysis optimization: normalization (`vitalsigns-utils`)
 * and vital-sign KPI cards (`optimization-vitals-utils`).
 */

/** @type {Array<{ apiKey?: string, apiKeys?: string[], label: string, unit: string }>} */
export const OPERATING_CONDITIONS_MAP = [
  {
    apiKeys: ["runningSpeedRpm", "driverSpeed"],
    label: "Driver Speed",
    unit: "RPM",
  },
  { apiKey: "turboEngineBoost", label: "Boost", unit: "PSIG" },
  { apiKey: "fuelGasUsed", label: "Fuel Gas Used", unit: "mscf/d" },
  { apiKey: "co2eEmission", label: "CO2e Emissions", unit: "tons/yr" },
  { apiKey: "totalAuxiliaryPowerUsed", label: "Aux. HP Used", unit: "HP" },
  {
    apiKeys: ["suctionPressure", "stationInletPressure"],
    label: "Station Inlet",
    unit: "psig",
  },
  { apiKey: "hourMeterReading", label: "Hour Meter", unit: "hrs" },
  { apiKey: "specificFuelConsumption", label: "SFC", unit: "BTU/HP-HR" },
  { apiKey: "nOxEmission", label: "NOx Emissions", unit: "tons/yr" },
  { apiKey: "dischargePressure", label: "Final Stg Disch Press", unit: "psig" },
  {
    apiKeys: ["reportedFlow", "unitFlow"],
    label: "Reported Flow",
    unit: "mmscfd",
  },
  {
    apiKeys: ["cylinderUtilizationPercent", "cylinderCapacityUtilized"],
    label: "Capacity Utilized",
    unit: "%",
  },
  {
    apiKeys: ["hpUtilizationPercent", "horsepowerUtilized"],
    label: "HP Utilized",
    unit: "%",
  },
];

/** @type {Array<{ apiKey?: string, apiKeys?: string[], label: string, unit: string }>} */
export const EQUIPMENT_INFO_MAP = [
  { apiKey: "frame", label: "Frame", unit: "" },
  { apiKey: "frameNumberOfStages", label: "Stages", unit: "" },
  { apiKey: "engineMaxHp", label: "Max HP", unit: "HP" },
  { apiKey: "recipFrameRodLoadType", label: "Rod Load Type", unit: "" },
  { apiKey: "legalLocation", label: "Location", unit: "" },
  { apiKey: "driver", label: "Driver", unit: "" },
  { apiKey: "frameNumberOfThrows", label: "Throws", unit: "" },
  { apiKey: "rpmRange", label: "RPM Range", unit: "" },
  { apiKey: "strokeLength", label: "Stroke Length", unit: '"' },
  { apiKey: "elevationFASL", label: "Elevation", unit: "ft" },
];

/** @type {Array<{ apiKey: string, displayName: string, unit: string }>} */
export const VITAL_SIGNS_MAP = [
  {
    apiKey: "cylinderUtilizationPercent",
    displayName: "Capacity Utilized",
    unit: "%",
  },
  { apiKey: "hpUtilizationPercent", displayName: "HP Utilized", unit: "%" },
  { apiKey: "runningSpeedRpm", displayName: "Driver Speed", unit: "RPM" },
  { apiKey: "suctionPressure", displayName: "Suction Pressure", unit: "psig" },
  { apiKey: "reportedFlow", displayName: "Reported Flow", unit: "mmscfd" },
  {
    apiKey: "dischargePressure",
    displayName: "Final Stg Disch Press",
    unit: "psig",
  },
];
